import React, { useState } from 'react';
import styled, {css} from 'styled-components';

import AnimateHeight from 'react-animate-height';

import Icon from 'components/icons/icon';

import theme, {bp, color} from 'settings/theme';


type Props = {
  question: string,
  answer: string
};

type StyledProps = Props & {
  isOpen: boolean
};

// Component
const Component: React.FC<Props> = (props) => {

  const [isOpen, setIsOpen] = useState(false);

	return(

    <StyledComponent {...props} isOpen={isOpen} className="faq">

      <div className="faq-layout">

        <div className="faq-layout-icon">
          <div className="faq-layout-icon-circle">
            <Icon iconName="chevron" iconDirection="right" />
          </div>
        </div>

        <div className="faq-layout-content">

          <button type="button" onClick={() => setIsOpen(!isOpen)} className="faq-question">
            {props.question}
          </button>

          <div className="faq-answer">
            <AnimateHeight
              duration={ 150 }
              height={isOpen ? 'auto' : 0}
            >
              <div className="faq-answer-inner">{props.answer}</div>
            </AnimateHeight>
          </div>

        </div>

      </div>

    </StyledComponent>
        
	)

}



export default Component;


// Styles
const StyledComponent = styled.div<StyledProps>`

  .faq-layout{
    display: flex;
  }

  .faq-layout-icon{
    display: flex;
    justify-content: center;
    flex: 0 0 auto;
    width: 24px;
    margin-right: 10px;
  }

  .faq-layout-content{
    flex: 1 1 auto;
  }

  .faq-layout-icon-circle{

    display: grid;
    place-items: center;
    width: 20px;
    height: 20px;
    border: solid 2px ${color.primary};
    border-radius: 10px;

    .icon{

      width: 9px;
      height: 9px;
      transition: transform 0.15s ease-out;

      svg{
        fill: ${color.primary};
      }

    }  

  }

  ${props => props.isOpen === true && css`
      
    .faq-layout-icon-circle{
        
      .icon{
        transform: rotate(0deg) !important;
      }

    }

  `}

  .faq-question{
    color: ${color.primary};
    font-family: ${theme.typography.fontFamilySecondary};
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .faq-answer{
    font-size: 14px;
  }

  .faq-answer-inner{
    padding-bottom: 1em;
  }


  @media (min-width: ${bp(3)}) {

    .faq-layout-icon{
      width: 28px;
      margin-right: 16px;
    }

    .faq-layout-icon-circle{

      width: 28px;
      height: 28px;
      border-radius: 14px;

      .icon{
        width: 15px;
        height: 15px;
      }  

    }


    .faq-question{
      font-size: 18px;
      padding-top: 4px;
      margin-bottom: 8px;
    }

    .faq-answer{
      font-size: 15px;
    }

  }

`;